export class ImageUtils {
    public static readonly ImageNotFountUrl = '/image-not-found.jpg'
    public static UrlOrImageNotFountUrl = (url: string | undefined | null) => !!url?.length ? url : ImageUtils.ImageNotFountUrl
}